import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import { Observable } from "rxjs";

import * as M from "../data/model";
import { PersistenceService } from "../store/model/persistence.service";
import { RootState } from "../store/root";
import { stateBuilder } from "../store/utils";

@Injectable()
export class SanitizerService {
    state$: Observable<LocalState>;

    constructor(
        private store: Store<RootState>,
        private persistence: PersistenceService,
    ) {
        this.state$ = LocalState.create(store);
        this.state$.subscribe((state) => {
            this.sanitize(state.model);
        });
    }

    protected sanitize(cp: M.ConsultationProcess) {}
}

class LocalState {
    model: M.ConsultationProcess;

    static create(store: Store<RootState>): Observable<LocalState> {
        return stateBuilder(store, new LocalState()).apply(
            "model",
            (s) => s.model.ConsultationProcess,
        ).state$;
    }
}
